import React, { Component } from 'react';
import $ from 'jquery';
import config from "../config";
import { gapi } from 'gapi-script';
import axios from 'axios';
import moment from 'moment';
import { ulid } from 'ulid';

import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import { Button, TextField, Table, TableSortLabel, TableBody, TableContainer, TableHead, TableRow } from '@mui/material';
import Paper from '@mui/material/Paper';
import TablePagination from '@mui/material/TablePagination';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import ReactHtmlParser, { processNodes, convertNodeToElement, htmlparser2 } from 'react-html-parser';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import OutlinedInput from '@mui/material/OutlinedInput';
import { saveAs } from 'file-saver';
import * as XLSX from 'xlsx';
import {DebounceInput} from 'react-debounce-input';

export default class MongoDBMoveMdsManager extends Component {
	
	constructor(props){
        super(props)
		this.state ={
			mdsJsonFilesVersion:new Map(),
			filesExist:false,
			page:0,
			rowsPerPage:10,
			filterMode:'',
			searchQuery:'',
			mdsSheets:[],
			staticIDMissed:[],
			missedMDSName:'',
			missedGuid:'',
			stMDSGuid:'',
		}

    }
	
	componentDidMount() {
		let that = this;
		setTimeout(function(){
			that.setState({mdsSheets:that.props.mdsSheets});
		}, 1000);
		
		setTimeout(function(){
			that.getMdsJsonFileVersion();
		}, 4000);
		
		//setInterval(this.checkFiles, 3000);
	}
	
	/* componentDidUpdate() {
		let that = this;
		setTimeout(function(){
			that.setState({mdsSheets:that.props.mdsSheets});
		}, 1000);
	} */
	
	getValue=(event)=>{
		let name = event.target.name;
		let res = event.target.value;
		this.setState({[event.target.name]:event.target.value});
		let that = this;
		if(name == 'filterMode'){
			setTimeout(function(){
				that.filterMdsForms();
			}, 1000);
		}
		
		if(name == 'selectedInstance'){
			this.props.getValue2(event);
			setTimeout(function(){
				that.setState({mdsSheets:that.props.mdsSheets});
				that.getMdsJsonFileVersion();
			}, 2000);
		}
		
		if(name == 'changeInstance'){
			
		}
	}
	
	moveMdsInstance=(MDSGuid) => {
		let instances = this.props.instances;
		let instanceId = this.state['IN-'+MDSGuid];
		let instanceName = '';
		instances.map((ins,i)=>{
			if(ins.InstanceGuild == instanceId){
				instanceName = ins.InstanceName;
			}
		})
		if(instanceId){
			let mongoApiUrl = config.mongoApiUrl;
			let url = mongoApiUrl+'move-instance';
			let formData = new FormData();
			formData.append('MDSGuid', MDSGuid);
			formData.append('InstanceGuild', instanceId);
			formData.append('InstanceName', instanceName);
			axios({
				method: 'POST',
				url: url,
				data: formData,
				headers: {
					'Content-Type': 'multipart/form-data'
				}
			})
			.then(response => {
				this.props.getMdsSheets(this.props.selectedInstanceId);
				let that = this;
				setTimeout(function(){
					that.filterMdsForms();
				}, 2000);
			}).catch(error => {
				console.log('error::', error);
			})
		}
	}
	
	handleSearch = (event) => {
		let that = this;
		this.setState({searchQuery:event.target.value});
		setTimeout(function(){
			that.filterMdsForms();
		}, 1000);
    };

	filterMdsForms=()=>{
		let mdsSheets = this.props.mdsSheets;
		let mdsForms = [];
		mdsSheets.map((sheet,i)=>{
			if(this.state.filterMode && this.state.filterMode != sheet.Mode){
				return false;
			}
			if(sheet.Fields){
				sheet['type'] = sheet.Fields[1][92];
				sheet['dtype'] = sheet.Fields[1][94];
				sheet['vtype'] = sheet.Fields[1][95];
				sheet['anatomy'] = sheet.Fields[1][96];
				
				let visibleTxt = [];
				let outputTxt = [];
				sheet.Fields.map((txt,i)=>{
					if(i > 0){
						if(txt[4]){
							visibleTxt.push(txt[4]);
						}
						if(txt[9]){
							outputTxt.push(txt[9]);
						}
					}
				});
				
				sheet['visibleTxt'] = visibleTxt.join(',');
				sheet['outputTxt'] = outputTxt.join(',');
			}
			mdsForms.push(sheet);
		});
		
		let searchQuery = this.state.searchQuery;
		
		if(searchQuery){
			mdsForms = mdsForms.filter((row) =>
				row.MDSName.toLowerCase().includes(searchQuery.toLowerCase()) ||
				row.Mode.toLowerCase().includes(searchQuery.toLowerCase()) ||
				row.Version && row.Version == searchQuery ||
				row.visibleTxt && row.visibleTxt.toLowerCase().includes(searchQuery.toLowerCase()) ||
				row.outputTxt && row.outputTxt.toLowerCase().includes(searchQuery.toLowerCase()) ||
				row.type && row.type.toLowerCase().includes(searchQuery.toLowerCase()) ||
				row.dtype && row.dtype.toLowerCase().includes(searchQuery.toLowerCase()) ||
				row.vtype && row.vtype.toLowerCase().includes(searchQuery.toLowerCase()) ||
				row.anatomy && row.anatomy.toLowerCase().includes(searchQuery.toLowerCase())
			);
		}
		//console.log('mdsForms->',mdsForms);
		this.setState({mdsSheets:mdsForms});
	}
		
	checkFiles=()=>{
		
		if(this.state.filesExist == false){
		   this.getMdsJsonFileVersion();
		}
	   
		if(this.props.mdsSheets){
		   this.setState({filesExist:true});
		}
	}
	
	getMdsJsonFileVersion=()=>{
		let mdsSheetGuids = [];
		
		this.props.mdsSheets.map((sheet,i)=>{
			mdsSheetGuids.push(sheet.MDSGuid);
		});
		
		let mongoApiUrl = config.mongoApiUrl;
		let url = mongoApiUrl+'mds-json-version-v2';
		axios({
			method: 'POST',
			url: url,
			data: JSON.stringify(mdsSheetGuids),
			headers: {
				'Content-Type': 'application/json',
			}
		})
		.then(response => {
			let files = response.data;
			if(files.length > 0){
				files.map((file,i)=>{
					if(file.Version){
						let mdsJsonFilesVersion = this.state.mdsJsonFilesVersion;
						mdsJsonFilesVersion.set(file.MDSGuid,file.Version);
						this.setState({mdsJsonFilesVersion});
					}
				});
			}
			
		}).catch(error => {
			console.log('error::', error);
		})
	}
	
	
	handleChangePage = (event: unknown, newPage: number) => {
		this.setState({page:newPage});
	};

	handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
		this.setState({rowsPerPage:event.target.value,page:0});
	};
	
	handleSort = column => {
		const { sortBy, sortOrder } = this.state;
		const isAsc = sortBy === column && sortOrder === 'asc';
		this.setState({
		  sortBy: column,
		  sortOrder: isAsc ? 'desc' : 'asc'
		});
	};
	
	render() {
		const {mdsJsonFilesVersion,layoutFriendlyName,selectedFiles,sortBy,sortOrder,mdsSheets,searchQuery,staticIDMissed,missedGuid,missedMDSName,stMDSGuid} = this.state;
		let FieldsCount = 0;
		let role = localStorage.getItem('role');
		const StyledTableCell = styled(TableCell)(({ theme }) => ({
		  [`&.${tableCellClasses.head}`]: {
			//backgroundColor: '#e9e9e9',
			color: '#000;',
			padding: '15px 5px;',
			fontWeight: 600,
			fontSize: 15,
		  },
		  [`&.${tableCellClasses.body}`]: {
			fontSize: 16,
			backgroundColor: '#ffffff',
		  },
		}));
		
		const sortedData = [...mdsSheets].sort((a, b) => {
		  const isAsc = sortOrder === 'asc';
		  if (a[sortBy] < b[sortBy]) {
			return isAsc ? -1 : 1;
		  }
		  if (a[sortBy] > b[sortBy]) {
			return isAsc ? 1 : -1;
		  }
		  return 0;
		});
		
		let optionInstance = '';
		if(this.props.instances){
			let ins = this.props.instances;
			optionInstance = ins.map(function(val,i) {
				return (
						<MenuItem value={val.InstanceGuild} key={i}>{val.InstanceName}</MenuItem>
					);
			})
		}
		
		let optionInstance2 = '';
		if(this.props.instances){
			let ins = this.props.instances;
			optionInstance2 = ins.map(function(val,i) {
				return (
						<option value={val.InstanceGuild} key={i}>{val.InstanceName}</option>
					);
			})
		}
		
		let missedDataTable = '';
		let that = this;
		if(staticIDMissed && missedGuid){
			missedDataTable = staticIDMissed.map(function(val,i) {
				if(missedGuid == val.MDSGuid){
					return (
						<tr key={i}><td className="v-list">{val.FieldGuide}</td><td className="v-list">{val.FieldID}</td><td className="v-list">{val.VisibleText}</td></tr>
					);
				}
			})
		}
		
		return (
			<div className="mds-manager-mongo custom-container">
				<div className="mongo-header">
					<div className="mg-page-title"><h4>Move MDS Manager</h4></div>
					{/* <div className="wp-check-filter">
						<button type="button" onClick={()=>this.checkMdsFields()} className="btn btn-info">Check MDS</button>
					</div> */}
					<div className="wp-mode-filter">
						<FormControl sx={{ m: 1, minWidth: 155, maxWidth: 250 }} size="small">
							<InputLabel>Select Mode</InputLabel>
							<Select
								value={this.state.filterMode ? this.state.filterMode : ""}
								name={'filterMode'}
								onChange={this.getValue}
								input={<OutlinedInput label="Select Mode" />}
							>
							<MenuItem value={''} >Select Mode</MenuItem>
							<MenuItem value={'Build'} >Build</MenuItem>
							<MenuItem value={'Test'} >Test</MenuItem>
							<MenuItem value={'Dev-Prod'} >Dev-Prod</MenuItem> 
							<MenuItem value={'Prod'} >Prod</MenuItem>
							
							</Select>
						</FormControl>
					</div>
					
					<div className="wp-mode-filter">
						<FormControl sx={{ m: 1, minWidth: 235, maxWidth: 235 }} size="small">
							<InputLabel>Select Instance</InputLabel>
							<Select
								value={this.props.selectedInstanceId}
								name={'selectedInstance'}
								onChange={this.getValue}
								input={<OutlinedInput label="Select Instance" />}
							>
							{optionInstance}
							</Select>
						</FormControl>
					</div>
					
					<div className="wp-search-filter">
							{/* <TextField
								label="Search"
								size="small"
								variant="outlined"
								fullWidth
								value={searchQuery}
								onChange={this.handleSearch}
								style={{ width: '200px' }}
							/> */}
							<DebounceInput debounceTimeout={500} type="text" className="form-control" name="searchQuery" value={searchQuery} onChange={this.handleSearch} placeHolder="Search" />
							<span className="search-icon"><i className="fa fa-search" aria-hidden="true"></i></span>
					</div>
					
					
					
				</div>
				
				{mdsSheets ?
				<div className="mg-child-sheets">
				<TableContainer>
				  <Table size="small" aria-label="a dense table">
					<TableHead>
					  <TableRow key={11}>
						<StyledTableCell>
						<TableSortLabel
							active={sortBy === 'MDSName'}
							direction={sortOrder}
							onClick={() => this.handleSort('MDSName')}
						>
						MDS Name
						</TableSortLabel>
						</StyledTableCell>
						<StyledTableCell>
						<TableSortLabel
							active={sortBy === 'ModifiedDate'}
							direction={sortOrder}
							onClick={() => this.handleSort('ModifiedDate')}
						>
						Last Updated
						</TableSortLabel>
						</StyledTableCell>
						<StyledTableCell>Mode</StyledTableCell>
						<StyledTableCell>F2 Version</StyledTableCell>
						<StyledTableCell>Ver.#</StyledTableCell>
						<StyledTableCell>In PostGres</StyledTableCell>
						<StyledTableCell>PostGres Ver.#</StyledTableCell>
						<StyledTableCell></StyledTableCell>
						
					  </TableRow>
					</TableHead>
					<TableBody>
					  {sortedData.slice(this.state.page * this.state.rowsPerPage, this.state.page * this.state.rowsPerPage + this.state.rowsPerPage).map((sheet) => {
						
						let mode = sheet.Mode ? sheet.Mode : 'Test';
						let mongoVersion = mdsJsonFilesVersion.get(sheet.MDSGuid);
						//let friendlyName = layoutFriendlyName.get(sheetGuid);
						
						let classn = 'not-in-mongo';
						if(mongoVersion && (mongoVersion == sheet.Version || sheet.Version == '')){
							classn = 'has-in-mongo';
						}
						let modeValue = sheet.Mode;
						
						let mState = this.state['mode-'+sheet.MDSGuid];
						if(mState){
							modeValue = mState;
						}
						
						FieldsCount = FieldsCount+sheet.FieldsCount;
						let lastUpdate = new Date(sheet.ModifiedDate).toLocaleString("en-US").replace(/[&\/\\#,+()$~%.'":*?<>{}]/g, '');
						let missed = false;
						if(staticIDMissed.length > 0){
							staticIDMissed.map((val,i) =>{
								if(val.MDSGuid == sheet.MDSGuid){
									missed = true;
								}
							})
						}
						
						return (<TableRow key={sheet.MDSGuid} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
						  <StyledTableCell width="400px">{sheet.MDSName}</StyledTableCell>
						  <StyledTableCell>{lastUpdate}</StyledTableCell>
						  <StyledTableCell>{modeValue}</StyledTableCell>
						  <StyledTableCell><i className={"fa fa-circle "+classn} aria-hidden="true"></i></StyledTableCell>
						  <StyledTableCell><i>{sheet.Version && sheet.Version != 1 ? sheet.Version : '1.01' }</i></StyledTableCell>
						  <StyledTableCell><i className={"fa fa-circle not-in-mongo"} aria-hidden="true"></i></StyledTableCell>
						  <StyledTableCell><i>1.01</i></StyledTableCell>
						  <StyledTableCell>
							<select className="form-control" name={'IN-'+sheet.MDSGuid} value={this.state['IN-'+sheet.MDSGuid] ? this.state['IN-'+sheet.MDSGuid] : sheet.InstanceGuild} onChange={this.getValue}>
								{optionInstance2}
							</select>
						  </StyledTableCell>
						  <StyledTableCell><button type="button" className="btn btn-primary move-btn" onClick={()=>this.moveMdsInstance(sheet.MDSGuid)}>Move</button></StyledTableCell>
						  
						  
						</TableRow>)
					  })}
					</TableBody>
				  </Table>
				</TableContainer>
				<TablePagination
					rowsPerPageOptions={[5, 10, 20, 50, 100]}
					component="div"
					count={mdsSheets.length}
					rowsPerPage={this.state.rowsPerPage}
					page={this.state.page}
					onPageChange={this.handleChangePage}
					onRowsPerPageChange={this.handleChangeRowsPerPage}
				/>
				</div>
				:null}
			</div>
		);	
	}	
}
